// extracted by mini-css-extract-plugin
export default {"contactUsItem":"ContactUsItem_contactUsItem__U3Li0","title":"ContactUsItem_title__m2CRY","message":"ContactUsItem_message__5yWW5","button":"ContactUsItem_button__4fjC3"};